export const WorkWeixinCanOpenBrands = [704015, 700031, 700597] // 企业能打开的品牌ID
